<template>
  <!-- <div class="back-to-old">
    <a href="">
      <span class="back-to-old-icon"></span>
      Eski Görünüme Dön
    </a>
  </div> -->
  <div class="flex-container">
    <div class="main-area">
      <!-- <ShopWelcomeBanner></ShopWelcomeBanner> -->
      <MobileAndTabletMenu v-if="isMobile || isTablet" :shopProfileData="shop">
        <template v-slot:shopProfileSlot>
          <ShopProfile :sellerShop="shop" :loading="isShopLoading" />
        </template>
        <template v-slot:shopPerformanceSlot>
          <ShopPerformance
            :sellerPerformanceMetrics="performanceMetrics"
            :loading="isPerformanceLoading"
          />
        </template>
        <template v-slot:bannerSlot>
          <DashboardRightSecondBanner
            :bannerItems="DASHBOARD_RIGHT_SECOND_BANNER"
            :isLoading="isBannerSecondLoading"
          />
        </template>
        <!-- <template v-slot:surveySlot>
          <SurveyCard
            :showSurvey="showSurvey"
            :show-survey-verification="showSurveyVerification"
            :show-survey-results="showSurveyResults"
            :survey-focus="surveyFocus"
            :survey-result="surveyResult"
            :survey="survey"
          />
        </template> -->
        <!-- <template v-slot:googleAdSlot>
          <GoogleADx
            v-if="isTablet"
            :googleAdId="checkAdType.right.slotId"
            :defineSlotParameter="checkAdType.right.slotName"
            :defineSlotSize="checkAdType.right.slotSize"
            :key="checkAdType.right.slotId"
          />
        </template> -->
      </MobileAndTabletMenu>
      <div class="w-full mb-20 user-summary">
        <Card>
          <template v-slot:content>
            <AdSummary
              :sellerShop="shop"
              :adData="adData"
              :loading="isAdSummaryLoading"
            ></AdSummary>
          </template>
        </Card>
      </div>
      <div class="card-wrapper">
        <Card
          cardTitle="Siparişlerim"
          :cardTitleStyle="{
            fontSize: '20px',
            fontWeight: '700',
            lineHeight: '26px',
            letterSpacing: '-0.2px',
          }"
        >
          <template v-slot:content>
            <OrdersCard
              :orderData="orderData"
              :loading="isOrderLoading"
            ></OrdersCard>
          </template>
          <template v-slot:separator>
            <Hr
              :style="{ marginTop: '8px', marginBottom: '12px' }"
              color="#EDEFF3"
            />
          </template>
          <template v-slot:footer>
            <div style="display: flex; flex-direction: column; gap: 20px">
              <div style="font-size: 18px; font-weight: 700">
                Sipariş Aksiyonlarım
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div style="font-size: 16px; font-weight: 400; cursor: pointer;"
                @click="
                    goToOldLookLink('/selleroffice/order/claim/claimRequests')
                  "
                >
                  İptal Talepleri
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                  "
                  @click="
                    goToOldLookLink('/selleroffice/order/claim/claimRequests')
                  "
                >
                  <div style="font-size: 20px; font-weight: 700">
                    {{ refundData?.cancelRequestCount }}
                  </div>
                  <img
                    src="../assets/images/arrow-right.svg"
                    alt="arrow-right"
                  />
                </div>
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 8px;
                  "
                >
                  <div style="font-size: 16px; font-weight: 400; cursor: pointer;"
                  @click="
                    goToOldLookLink(
                      '/selleroffice/order/claim/claimRequests?tabIndex=1'
                    )
                  "
                  >
                    İade Talepleri
                  </div>
                  <DelayCard
                    v-if="refundData?.lateReturnRequestCount > 0"
                    :delayCount="refundData?.lateReturnRequestCount"
                    :link="`/selleroffice/order/claim/claimRequests?tabIndex=1`"
                  >
                  </DelayCard>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                  "
                  @click="
                    goToOldLookLink(
                      '/selleroffice/order/claim/claimRequests?tabIndex=1'
                    )
                  "
                >
                  <div style="font-size: 20px; font-weight: 700">
                    {{ refundData?.returnRequestCount || 0 }}
                  </div>
                  <img src="../assets/images/arrow-right.svg" alt="" />
                </div>
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div style="font-size: 16px; font-weight: 400; cursor:pointer;"
                @click="
                    goToOldLookLink(
                      '/selleroffice/product/productQuestions?questionSource=ORDER_QUESTION'
                    )
                  "
                >
                  Sipariş Soruları
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                  "
                  @click="
                    goToOldLookLink(
                      '/selleroffice/product/productQuestions?questionSource=ORDER_QUESTION'
                    )
                  "
                >
                  <div style="font-size: 20px; font-weight: 700">
                    {{ customerData?.ordersQuestionCount || 0 }}
                  </div>
                  <img src="../assets/images/arrow-right.svg" alt="" />
                </div>
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div style="font-size: 16px; font-weight: 400; cursor:pointer;"
                @click="
                    goToOldLookLink(
                      '/selleroffice/product/productQuestions?tab=seller&direction=INCOMING'
                    )
                  "
                >
                  Sorduğum Sorular
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                  "
                  @click="
                    goToOldLookLink(
                      '/selleroffice/product/productQuestions?tab=seller&direction=INCOMING'
                    )
                  "
                >
                  <div style="font-size: 20px; font-weight: 700">
                    {{ customerData?.incomingSellerOrderQuestionCount || 0 }}
                  </div>
                  <img src="../assets/images/arrow-right.svg" alt="" />
                </div>
              </div>
            </div>
          </template>
        </Card>
      </div>
      <div class="card-wrapper ml-20">
        <Card
          cardTitle="Ürünlerim"
          :cardTitleStyle="{
            fontSize: '20px',
            fontWeight: '700',
            lineHeight: '26px',
            letterSpacing: '-0.2px',
          }"
        >
          <template v-slot:content>
            <RefundCard
              :refundData="productData"
              :loading="isRefundLoading"
            ></RefundCard>
          </template>
          <template v-slot:separator>
            <Hr
              :style="{ marginTop: '8px', marginBottom: '12px' }"
              color="#EDEFF3"
            />
          </template>
          <template v-slot:footer>
            <div class="footer-wrapper">
              <div class="title">Ürün Aksiyonlarım</div>
              <div class="action-container">
                <div class="action-text" @click="goToLink('pending_actions')">Onayınızı Bekleyen Ürünler</div>
                <div class="action-count" @click="goToLink('pending_actions')">
                  <span class="count">{{
                    productData?.underInvestigation || 0
                  }}</span>
                  <img src="@/assets/images/arrow-right.svg" alt="Sağa ok" />
                </div>
              </div>
              <div class="action-container">
                <div class="action-text" @click="goToLink('catalog_rejected')">Düzenlemeniz Gereken Ürünler</div>
                <div class="action-count" @click="goToLink('catalog_rejected')">
                  <span class="count">{{ productData?.rejected || 0 }}</span>
                  <img src="@/assets/images/arrow-right.svg" alt="Sağa ok" />
                </div>
              </div>
              <div class="action-container">
                <div 
                  class="action-text"
                  @click="
                    goToOldLookLink(
                      '/selleroffice/product/productQuestions?questionSource=PRODUCT_QUESTION'
                    )
                  "
                >
                Ürün Soruları
               </div>
                <div
                  class="action-count"
                  @click="
                    goToOldLookLink(
                      '/selleroffice/product/productQuestions?questionSource=PRODUCT_QUESTION'
                    )
                  "
                >
                  <span class="count">{{
                    customerData?.productsQuestionCount || 0
                  }}</span>
                  <img src="@/assets/images/arrow-right.svg" alt="Sağa ok" />
                </div>
              </div>
            </div>
            <div
              v-if="productData.productDealOfferInfoText"
              class="offer-container"
            >
              <div class="offer-left">
                <img src="@/assets/images/announcement.svg" alt="Duyuru" />
                <p>Size Özel Komisyon Teklifleri</p>
              </div>
              <a class="offer-link" href="/product-deal">Teklifleri Gör</a>
            </div>
          </template>
        </Card>
      </div>
      <div class="card-wrapper">
        <Card cardTitle="Fatura Durumu">
          <template v-slot:content>
            <InvoiceCard
              :invoiceData="invoiceData"
              :loading="isCustomerLoading"
            />
          </template>
        </Card>
      </div>
      <div class="card-wrapper ml-20">
        <Card cardTitle="Size Özel Hazırladık">
          <template v-slot:content>
            <div class="quick-access">
              <QuickAccess :cardItems="cardItems" />
            </div>
          </template>
        </Card>
      </div>
      <div class="sales-graph-card">
        <Card
          cardTitle="Mağaza Satış Grafiği"
          cardRightTitle="Tümünü Gör"
          hasImage="true"
          :cardRightTitleFn="
            () => goToOldLookLink('/selleroffice/app/analytics')
          "
        >
          <template v-slot:content>
            <SalesGraph
              :chartData="chartResponseData.val"
              :loading="chartResponseDataLoading"
              @requestNewDays="setNewRequest"
            >
            </SalesGraph>
          </template>
        </Card>
      </div>
      <DashboardLeftFirstDoubleBanner
        :bannerItems="DASHBOARD_LEFT_FIRST_BANNER"
        :isLoading="isBannerSecondLoading"
      />
      <!-- <GoogleADx
        :googleAdId="checkAdType.top.slotId"
        :defineSlotParameter="checkAdType.top.slotName"
        :defineSlotSize="checkAdType.top.slotSize"
        :key="checkAdType.top.slotId"
      /> -->
      <div v-if="false" class="campaign-card">
        <Card :color="'#3dbbd1'" cardTitle="Kampanyalar">
          <template v-slot:content>
            <CampaignCard
              :campaignData="campaignData.val"
              :loading="isCampaignLoading"
            />
          </template>
        </Card>
      </div>
      <div v-if="false" class="support-card">
        <Card :color="'#3dbbd1'" cardTitle="Mağaza Destek">
          <template v-slot:content>
            <ShopSupportCard
              :supportData="supportData.val"
              :loading="isSupportLoading"
            />
          </template>
        </Card>
      </div>
      <!-- <div v-if="!isTablet || isMobile" class="statistics">
        <div class="dummy"></div>
      </div>
      <div v-if="!isTablet || isMobile" class="support-card">
        <div class="dummy"></div>
      </div> -->
      <!-- <GoogleADx
        :googleAdId="checkAdType.bottom.slotId"
        :defineSlotParameter="checkAdType.bottom.slotName"
        :defineSlotSize="checkAdType.bottom.slotSize"
        :key="checkAdType.bottom.slotId"
      /> -->
    </div>
    <div class="side-area" v-if="!isTablet">
      <div class="card-content-item">
        <div class="d-flex flex-column">
          <div class="d-flex rp-point-content">
            <div>
              <span>Toplam Reklam Puanı: </span>
            </div>
            <div class="card-content-result">
              <strong>
                {{
                  $filters.formatNumberFilter(
                    adData.adSummaryData?.sellerPointAccount?.content[0]
                      ?.effectiveBalance
                  )
                }}
              </strong>
            </div>
          </div>
          <div>
            <span class="user-summary-info"
              >Puan satın alarak ürünlerinizi öne çıkarın.</span
            >
          </div>
        </div>
        <div v-if="adData?.buttonTitle" class="button">
          <AppButton
            primary
            sm
            id="primary1"
            :title="adData?.buttonTitle"
            @buttonClick="
              () =>
                primaryClick(
                  adData?.buttonTitle === 'Reklam Ver'
                    ? 'dashboard'
                    : 'buyadpoint'
                )
            "
          >
          </AppButton>
        </div>
      </div>

      <div class="details-banner-area">
        <Card>
          <template v-slot:content>
            <DashboardRightFirstBanner
              :bannerItems="DASHBOARD_RIGHT_SECOND_BANNER"
              :isLoading="isBannerSecondLoading"
            />
          </template>
        </Card>
      </div>
      <div v-if="!isMobile" class="shop-performance-card">
        <ShopPerformance
          :sellerPerformanceMetrics="performanceMetrics"
          :loading="isPerformanceLoading"
        />
      </div>

      <div v-if="announcements.length" class="announcements">
        <div class="rectangle-card">
          <div class="header">
            <h1 class="headerTitle">Duyurular</h1>
            <div
              class="headerRight"
              @click="
                goToOldLookLink('/selleroffice/ssc/sellernotice/sellerNotice')
              "
            >
              <div class="detailButton">Tümünü Gör</div>
              <div class="right-arrow"></div>
            </div>
          </div>
          <div
            @click="annoucementClick(annoucement.id)"
            v-for="annoucement in announcements.slice(0, 5)"
            :key="annoucement.id"
            class="announcement"
          >
            <div class="date">
              <span class="day">
                {{ getDay(annoucement.createdDate) }}
              </span>
              <span class="mounth">
                {{ getMonth(annoucement.createdDate) }}
              </span>
            </div>
            <div class="details">
              <div class="announcementText">
                {{ truncatedText(annoucement.title, 70) }}
              </div>
              <div class="priority" v-if="annoucement.topPriority">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="7.19995" cy="7.19995" r="6" fill="#4FA4E5"/>
                  <path 
                  d="M7.2002 6.59961C7.50776 6.59971 7.76118 6.83162 7.7959 7.12988L7.7998 7.2002V9.59961C7.7998 9.93092 7.53148 10.2001 7.2002 10.2002C6.89249 10.2002 6.63915 9.96832 6.60449 9.66992L6.59961 9.59961V7.2002C6.59961 6.86882 6.86882 6.59961 7.2002 6.59961ZM7.2002 4.2002C7.53141 4.2003 7.7997 4.46859 7.7998 4.7998C7.7998 5.13111 7.53148 5.40029 7.2002 5.40039C6.86882 5.40039 6.59961 5.13118 6.59961 4.7998C6.59971 4.46852 6.86889 4.2002 7.2002 4.2002Z" 
                  fill="white"
                  />
                </svg>
                <span>Önemli!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SurveyCard
        ref="surveyCard"
        :showSurvey="showSurvey"
        :show-survey-verification="showSurveyVerification"
        :show-survey-results="showSurveyResults"
        :survey-focus="surveyFocus"
        :survey-result="surveyResult"
        :survey="survey"
      />
      <div class="opportunities-card">
        <Card cardTitle="Fırsatlar">
          <template v-slot:content>
            <DashboardRightFirstBanner
              :bannerItems="DASHBOARD_RIGHT_FIRST_BANNER"
            />
          </template>
        </Card>
      </div>
      <!--TODO: whats the purpose of this details banner? Need to learn from business and should be named properly -->

      <!-- <GoogleADx
        :googleAdId="checkAdType.right.slotId"
        :defineSlotParameter="checkAdType.right.slotName"
        :defineSlotSize="checkAdType.right.slotSize"
        :key="checkAdType.right.slotId"
      /> -->
    </div>
    <div>
      <Modal
        :withCloser="false"
        ref="surveyModal"
        title="📋Ankete Katıl"
        positive-action-text="Hemen Başla"
        @onPositiveActionClick="surveyModalPositiveClick"
        modalWidth="400"
      >
        <template v-slot:body>
          <span class="surveyModalContent">
            Sadece birkaç soru ile SO deneyimini sana özel hale getireceğiz.
          </span>
        </template>
      </Modal>
    </div>
  </div>
  <Modal
    :withCloser="false"
    ref="sellerLoginModal"
    positive-action-text="Tamam"
    @onPositiveActionClick="sellerLoginModalPositiveClick"
    modalStyle="width: 460px;"
    :showIcon="false"
  >
    <template v-slot:body>
      <div v-html="sellerLoginModalData.content"></div>
    </template>
  </Modal>
  <Modal
    :withCloser="true"
    ref="annoucementModal"
    positive-action-text="Tamam"
    @onPositiveActionClick="annoucementModalPositiveClick"
    isCornerButton
    modalStyle=""
    :showIcon="false"
  >
    <template v-slot:body>
      <div v-html="annoucementModalData.content"></div>
    </template>
  </Modal>
</template>

<script>
import Cookies from '@/utils/cookie';
import { Card, Modal, Hr, AppButton } from "@n11/so-ui-components";
import CampaignCard from "@/components/CampaignCard/CampaignCard";
import SalesGraph from "@/components/SalesGraph/SalesGraph";
import QuickAccess from "@/components/QuickAccess/QuickAccess";
import InvoiceCard from "@/components/InvoiceCard/InvoiceCard";
import ShopSupportCard from "@/components/ShopSupportCard/ShopSupportCard";
import OrdersCard from "@/components/OrdersCard/OrdersCard";
import AdSummary from "@/components/AdSummary/AdSummary";
// import ProductCard from "@/components/ProductCard/ProductCard";
import RefundCard from "@/components/RefundCard/RefundCard";
import { ref, computed, reactive, watch } from "vue";
import { useStore } from "vuex";
import ShopPerformance from "@/components/ShopPerformance/ShopPerformance";
import ShopProfile from "@/components/ShopProfile/ShopProfile";
import MobileAndTabletMenu from "@/components/MobileAndTabletMenu/MobileAndTabletMenu";
// import GoogleADx from '@/components/GoogleAd/GoogleADx';
import { adSummaryControl } from "@/utils/adSummaryControl/adSummaryControl";
import { slotNames } from "@/utils/googleAdSlotNames";
import { MOBILE, DESKTOP } from "@/utils/enum/generalEnums";
import SurveyCard from "../components/SurveyCard/SurveyCard";
import DashboardRightFirstBanner from "../components/Banners/DashboardRightFirstBanner";
import DashboardLeftFirstDoubleBanner from "../components/Banners/DashboardLeftFirstDoubleBanner";
import DashboardRightSecondBanner from "../components/Banners/DashboardRightSecondBanner";
import { getDay, getMonth } from "../utils/formatedDate";
import { truncatedText } from "../utils/formatedText";
import storeIcon from "@/assets/images/icons/store-primary.svg";
import contractIcon from "@/assets/images/icons/contract-primary.svg";
import eCommerceIcon from "@/assets/images/icons/e-commerce-primary.svg";
import DelayCard from "@/components/DelayCard/DelayCard";
import { ENVIRONMENT_HOSTS } from "@/utils/enum/enviromentHosts";

export default {
  name: "Home",
  components: {
    CampaignCard,
    Card,
    InvoiceCard,
    // ProductCard,
    ShopPerformance,
    ShopProfile,
    OrdersCard,
    RefundCard,
    DashboardLeftFirstDoubleBanner,
    DashboardRightFirstBanner,
    DashboardRightSecondBanner,
    SurveyCard,
    Modal,
    MobileAndTabletMenu,
    // GoogleADx,
    ShopSupportCard,
    AdSummary,
    SalesGraph,
    QuickAccess,
    Hr,
    AppButton,
    DelayCard,
  },
  data() {
    return {
      cardItems: [
        {
          href: "https://magazadestek.n11.com/satis-surecleri",
          target: "_blank",
          icon: storeIcon,
          label: "Mağaza Süreç <br> Rehberi",
        },
        {
          href: "https://magazadestek.n11.com/sinif-ici-ve-canli-egitimler",
          target: "_blank",
          icon: contractIcon,
          label: "Eğitim <br> Programları",
        },

        {
          href: "https://magazadestek.n11.com/s/e-ticaret-cozumleri",
          target: "_blank",
          icon: eCommerceIcon,
          label: "E-Ticaret <br> Çözümleri",
        },
      ],
    };
  },
  setup() {
    let isButtonClicked = false;
    const annoucementClick = async (id) => {
      isButtonClicked = true;
      await getAnnoucementModal(id);
      surveyFocus.value = false;
      annoucementModal.value.openModal();
    };

    async function getAnnoucementModal(id) {
      if (!isButtonClicked) return;
      await store.dispatch("dashboard/getAnnoucements").then((response) => {
        annoucementModalData.content = selectedAnnoucement(response, id);
        response.show && openAnnoucementModal();
      });
    }

    const selectedAnnoucement = (response, id) => {
      return response.find((item) => item.id === id)?.content;
    };

    const store = useStore();

    const campaignData = reactive({ val: {} });

    const customerData = ref({});
    const productData = ref({});
    const performanceMetrics = ref({});
    const shop = ref({});
    const announcements = ref([]);
    const DASHBOARD_LEFT_FIRST_BANNER = ref([]);
    const DASHBOARD_RIGHT_FIRST_BANNER = ref([]);
    const DASHBOARD_RIGHT_SECOND_BANNER = ref([]);
    const refundData = ref({});
    const orderData = ref({});
    const isBannerFirstLoading = ref(false);
    const isBannerSecondLoading = ref(false);
    const isPerformanceLoading = ref(false);
    const isShopLoading = ref(false);
    const isOrderLoading = ref(false);
    const isRefundLoading = ref(false);
    const isCustomerLoading = ref(false);
    const isAdSummaryLoading = ref(false);
    const isProductLoading = ref(false);
    const isCampaignLoading = ref(false);
    const chartResponseDataLoading = ref(false);
    const size = ref(window.innerWidth);
    const chartResponseData = reactive({
      val: null,
    });
    
    const survey = computed(() => {
      const storeSurvey = store.getters['surveys/getSurveys'];
      return storeSurvey || {};
    });
    
    const authState = computed(() => ({
      user: store.getters['auth/user'],
      isLoggedIn: store.getters['auth/isLoggedIn'],
      isPending: store.getters['auth/isPending']
    }));
    
    const surveyModal = ref();
    const annoucementModal = ref();
    const surveyFocus = ref(false);
    const sellerLoginModal = ref();
    const sellerLoginModalData = reactive({
      content: "",
      isShow: false,
    });
    const annoucementModalData = reactive({
      content: "",
      show: false,
    });

    const adData = ref({
      title: null,
      adSummaryData: null,
      buttonTitle: null,
      buttonIcon: null,
      cardTitleHref: null,
      buttonHref: null,
      footerTitle: null,
      footerTitleHref: null,
      titleLink: null,
      footerIcon: null,
      gift: null,
    });
    const isSupportLoading = ref(false);
    const supportData = reactive({
      val: {},
    });
    const surveyCard = ref();

    const invoiceData = ref({});

    const TEST_SO_N11 = ENVIRONMENT_HOSTS.TEST_SO_N11;

    const isMobile = computed(() => {
      return size.value < 768;
    });
    const isTablet = computed(() => {
      return size.value < 1200 && !isMobile.value;
    });
    const showSurveyVerification = computed(() => {
      return store.getters["surveys/getShowSurveyVerification"];
    });
    const showSurveyResults = computed(() => {
      return store.getters["surveys/getShowSurveyResults"];
    });
    const showSurvey = computed(() => {
      return store.getters["surveys/getShowSurvey"];
    });
    const surveyResult = computed(() => {
      return store.getters["surveys/getSurveyResult"];
    });
    const isSurveyPending = computed(() => {
      return store.getters["surveys/getSurveyPending"];
    });
    const checkAdType = computed(() => {
      if (isMobile.value) {
        return setAdSlotNames(MOBILE);
      }
      return setAdSlotNames(DESKTOP);
    });

    const setNewRequest = (val) => {
      getSalesGraphData(val);
    };

    async function getNotification() {
      await store.dispatch("dashboard/notificationQuery");
    }

    async function getSellerBanner() {
      DASHBOARD_RIGHT_FIRST_BANNER.value = await store.dispatch(
        "dashboard/getSellerBanner"
      );
    }

    async function getSellerPerformanceMetrics() {
      isPerformanceLoading.value = true;
      store
        .dispatch("dashboard/getSellerPerformanceMetrics")
        .then((res) => {
          performanceMetrics.value = res;
        })
        .finally(() => {
          isPerformanceLoading.value = false;
        });
    }
    async function getSellerShop() {
      isShopLoading.value = true;
      store
        .dispatch("dashboard/getSellerShop")
        .then((res) => {
          shop.value = res;
        })
        .finally(() => {
          isShopLoading.value = false;
        });
    }
    async function getAnnoucements() {
      announcements.value = await store.dispatch("dashboard/getAnnoucements");
    }

    async function getCustomerModule() {
      isCustomerLoading.value = true;
      store
        .dispatch("dashboard/getCustomerModule")
        .then((res) => {
          customerData.value = res;
        })
        .finally(() => {
          isCustomerLoading.value = false;
        });
    }
    async function getInvoiceModule() {
      isCustomerLoading.value = true;
      store
        .dispatch("dashboard/getInvoiceModule")
        .then((res) => {
          invoiceData.value = res;
        })
        .finally(() => {
          isCustomerLoading.value = false;
        });
    }

    async function getProductsModule() {
      isProductLoading.value = true;
      store
        .dispatch("products/getProductsModule")
        .then((res) => {
          productData.value = res;
        })
        .finally(() => {
          isProductLoading.value = false;
        });
    }

    async function getCreatingNewBannerModule() {
      isBannerFirstLoading.value = true;
      store
        .dispatch("dashboard/getCreatingNewBannerModule")
        .then((res) => {
          isBannerFirstLoading.value = false;
          DASHBOARD_LEFT_FIRST_BANNER.value = res;
        })
        .catch(() => {
          isBannerFirstLoading.value = false;
        });
    }

    async function getCampaignsBanner() {
      isCampaignLoading.value = true;
      store
        .dispatch("dashboard/getCampaignsBanner")
        .then((res) => {
          campaignData.val = res;
        })
        .finally(() => {
          isCampaignLoading.value = false;
        });
    }

    async function getDetailsBannerImage() {
      isBannerSecondLoading.value = true;
      store
        .dispatch("dashboard/getDetailsBannerImage")
        .then((res) => {
          isBannerSecondLoading.value = false;
          DASHBOARD_RIGHT_SECOND_BANNER.value = res;
        })
        .catch(() => {
          isBannerSecondLoading.value = false;
        });
    }
    async function getRefundModule() {
      isRefundLoading.value = true;
      store
        .dispatch("dashboard/getRefundModule")
        .then((res) => {
          refundData.value = res;
        })
        .finally(() => {
          isRefundLoading.value = false;
        });
    }
    async function getOrderModule() {
      isOrderLoading.value = true;
      store
        .dispatch("dashboard/getOrderModule")
        .then((res) => {
          orderData.value = res;
        })
        .finally(() => {
          isOrderLoading.value = false;
        });
    }
    async function getSurveysModule() {
      try {
  
        const response = await store.dispatch("surveys/getSurveysModule");

        
        const shouldOpenSurveyModal =
          response?.sellerOfficePrivileged &&
          response?.surveyQuestions?.length > 0;

        if (shouldOpenSurveyModal) {
          openSurveyModal();
        }
      } catch (error) {
        console.error('Error in getSurveysModule:', error);
      }
    }

    async function getSupportModule() {
      isSupportLoading.value = true;
      store
        .dispatch("dashboard/getShopSupportInventory")
        .then((res) => {
          supportData.val = res;
        })
        .finally(() => {
          isSupportLoading.value = false;
        });
    }

    async function getSalesGraphData(range) {
      chartResponseDataLoading.value = true;
      store
        .dispatch("dashboard/getChartData", range)
        .then((res) => {
          chartResponseData.val = res;
        })
        .finally(() => {
          chartResponseDataLoading.value = false;
        });
    }

    function surveyModalPositiveClick() {
      surveyModal.value.hiddenModal();
      surveyFocus.value = false;
      if (!isTablet.value) {
        const surveyCardElement = surveyCard.value.$el;
        surveyCardElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }
    }

    function annoucementModalPositiveClick() {
      annoucementModal.value.hiddenModal();
      annoucementModalData.content = "";
    }

    async function getSellerLoginModal() {
      await store.dispatch("auth/getSellerLoginModal").then((response) => {
        sellerLoginModalData.content = response?.content;

        response.isShow &&
          !Cookies.get("SellerLoginModal") &&
          openSellerLoginModal();
      });
    }

    function sellerLoginModalPositiveClick() {
      sellerLoginModal.value.hiddenModal();
      Cookies.set("SellerLoginModal", true, {
        expires: new Date(new Date().getTime() + 6 * 60 * 1000),
      });
    }

    function openSellerLoginModal() {
      sellerLoginModal.value.openModal();
    }

    function openSurveyModal() {
      surveyModal.value.openModal();
      surveyFocus.value = true;
    }

    function openAnnoucementModal() {
      annoucementModal.value.openModal();
    }

    function setAdSlotNames(type) {
      return slotNames[type];
    }

    async function getAddsModule() {
      isAdSummaryLoading.value = true;
      await store
        .dispatch("dashboard/getAdSummaryModule", { days: 3 })
        .then((adSummary) => {
          adData.value = adSummaryControl(adSummary);
        })
        .finally(() => {
          isAdSummaryLoading.value = false;
        });
    }

    const primaryClick = (param) => {
      const baseUrl = adData.value.buttonHref;
      const url = param
        ? `${baseUrl}?param=${encodeURIComponent(param)}`
        : baseUrl;
      window.location.href = url;
    };

    const goToLink = (tabKey) => {
      window.location.href = `${TEST_SO_N11}/selleroffice/v2/product/products?tab=${tabKey}`;
    };
    //eski gorunum linklerine
    const goToOldLookLink = (link) => {
      window.location.href = `${TEST_SO_N11}${link}`;
    };

    getSellerLoginModal();
    getSellerBanner();
    getSellerPerformanceMetrics();
    getSellerShop();
    getCustomerModule();
    getProductsModule();
    getSupportModule();
    getCreatingNewBannerModule();
    getCampaignsBanner();
    getDetailsBannerImage();
    getRefundModule();
    getOrderModule();
    getAddsModule();
    getAnnoucements();
    getAnnoucementModal();
    getInvoiceModule();
    getNotification();

    let surveyCalled = false;

    watch(authState, (newAuthState, oldAuthState) => {
      
      if (!newAuthState.isPending && 
          newAuthState.user?.sellerId && 
          !surveyCalled) {
        surveyCalled = true;
        getSurveysModule();
      }
    }, { immediate: true });

    window.addEventListener(
      "resize",
      (event) => {
        size.value = event.target.innerWidth;
      },
      true
    );

    return {
      performanceMetrics,
      shop,
      customerData,
      productData,
      supportData,
      campaignData,
      DASHBOARD_LEFT_FIRST_BANNER,
      DASHBOARD_RIGHT_FIRST_BANNER,
      DASHBOARD_RIGHT_SECOND_BANNER,
      refundData,
      orderData,
      size,
      isMobile,
      isTablet,
      isShopLoading,
      isSupportLoading,
      isOrderLoading,
      isRefundLoading,
      isCustomerLoading,
      isProductLoading,
      isPerformanceLoading,
      isBannerFirstLoading,
      isBannerSecondLoading,
      isCampaignLoading,
      survey,
      surveyModal,
      surveyFocus,
      showSurveyVerification,
      showSurveyResults,
      showSurvey,
      surveyResult,
      isSurveyPending,
      surveyModalPositiveClick,
      annoucementModalPositiveClick,
      sellerLoginModal,
      sellerLoginModalData,
      sellerLoginModalPositiveClick,
      annoucementModalData,
      adData,
      isAdSummaryLoading,
      chartResponseData,
      chartResponseDataLoading,
      setNewRequest,
      checkAdType,
      surveyCard,
      announcements,
      annoucementClick,
      truncatedText,
      annoucementModal,
      getMonth,
      getDay,
      primaryClick,
      invoiceData,
      goToLink,
      goToOldLookLink,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.back-to-old {
  width: 100% !important;
  max-width: 100% !important;
  align-items: flex-end;
  display: flex;
  padding-right: 30px;
  justify-content: flex-end;
  margin-top: 16px;

  a {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;

    span {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.4714 4.13807C7.73175 3.87772 7.73175 3.45561 7.4714 3.19526C7.21105 2.93491 6.78894 2.93491 6.5286 3.19526L3.19526 6.5286C3.13134 6.59251 3.08312 6.66618 3.05059 6.74481C3.01799 6.82342 3 6.90961 3 7C3 7.09039 3.01799 7.17658 3.05059 7.25519C3.08238 7.33203 3.12916 7.40414 3.19093 7.46703M3.19566 7.4718L6.5286 10.8047C6.78894 11.0651 7.21105 11.0651 7.4714 10.8047C7.73175 10.5444 7.73175 10.1223 7.4714 9.86193L5.27614 7.66667H11.6667C12.1971 7.66667 12.7058 7.87738 13.0809 8.25245C13.456 8.62753 13.6667 9.13623 13.6667 9.66667V14.3333C13.6667 14.7015 13.9651 15 14.3333 15C14.7015 15 15 14.7015 15 14.3333V9.66667C15 8.78261 14.6488 7.93476 14.0237 7.30964C13.3986 6.68452 12.5507 6.33333 11.6667 6.33333H5.27614L7.4714 4.13807' fill='%235D3EBC'/%3E%3C/svg%3E");
      width: 18px;
      height: 18px;
      display: block;
    }
  }
}

.card-content-item {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 20px !important;

  span,
  strong {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.05px;
    margin-right: 4px;
  }
  strong {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.05px;
  }

  .user-summary-info {
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 138.462% */
    letter-spacing: -0.05px;
    white-space: nowrap;
  }

  .rp-point-content {
    margin-bottom: 0 !important;
    height: 20px;
  }
  .button {
    margin-bottom: 3px !important;
  }
}
.flex-container {
  display: flex;
  margin-top: 30px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px !important;
  .headerRight {
    display: flex;
    cursor: pointer;
  }
}

.main-area {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.icon-img {
  width: auto;
  height: 70px;
  margin: 16px 16px 12px 16px;
}

.rectangle-card {
  width: 100%;
  padding: 20px;
  border-radius: 8px;
  background-color: $colorN00;
  height: auto;
}

.announcement {
  display: flex;
  border-bottom: 0.5px solid $colorD30;
  gap: 16px;
  padding: 16px 0px 16px 0px;
  margin-bottom: 0 !important;
}

.announcement:hover .day,
.announcement:hover .mounth {
  cursor: pointer;
  color: $colorB60;
}

.announcement:hover .date {
  background: $colorB05;
}
.announcement:hover .title {
  background: $colorB05;
}
.announcement:hover .announcementText { font-weight: 700; }

.headerTitle {
  color: $dark-gray-5;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.announcement:last-child {
  border-bottom: none;
}

.details {
  margin-bottom: 0 !important;
}

.announcementText {
  color: $colorN80;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.05px;
}
.priority {
  display: flex;
  height: 24px;
  width: 70px;
  padding: 12px 6px;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
  border: 0.5px solid $colorB20;
  background: $colorB05;

  span {
    color: $colorB50;
    font-feature-settings: "liga" off, "clig" off;
    /* 02 Texts/Text/11px - N80/Semibold */
    font-family: "Open Sans";
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px; /* 127.273% */
  }
}

.detailButton {
  color: $colorM50;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.05px;
  cursor: pointer;
}

.date {
  border-radius: 8px;
  background: $colorD10;
  display: flex;
  padding: 7px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 47px;
  height: 48px;
}

.day {
  color: $colorD60;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.05px;
  width: 33px;
  height: 20px;
}

.mounth {
  width: 26px;
  height: 14px;
  color: $colorD50;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
}

.clear {
  margin: 0 !important;
}

.opportunities-card {
  max-width: 326px;
}

.dummy {
  height: 356px;
  padding: 0 20px 9px 0;
  border-radius: 8px;
  background-color: $colorN00;
}

.campaign-card {
  width: 100%;
  margin-bottom: 20px;
}

.quick-access,
.sales-graph-card {
  width: 100%;
  margin-bottom: 20px;
}

.side-area {
  display: flex;
  flex-direction: column;
  width: 26%;
  max-width: 326px;

  div:nth-child(n) {
    margin-bottom: 10px;
  }
}

.statistics {
  margin-left: 30px;
  width: 100%;
  margin-bottom: 20px;
}

.support-card {
  margin-bottom: 20px;
  width: 100%;
}

.card-wrapper {
  max-width: 470px;
  flex-grow: 1;
  width: 46%;
  height: auto;
  margin-bottom: 20px;
  max-width: 100%;
}

.performance {
  margin: 0;
  height: auto;
}

.shop-profile-card {
  max-width: 326px;
}

.box {
  background-color: $colorN00;
  width: 100%;
  display: flex;
  height: 48.5px;
  align-items: center;
  margin-top: 58px;
  justify-content: space-between;
}

.open {
  background-color: $colorN00;
  width: 100%;
  height: 166px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.open-performance {
  background-color: $colorN00;
  width: 100%;
  height: auto;
  align-items: flex-start;
}

.image-position {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}

.title-position {
  margin-left: 16px;
  font-weight: bold;
}

.open-title-position {
  margin-top: 17px;
  margin-left: 0;
  font-weight: bold;
}

.open-box-image {
  margin-top: 11px;
  margin-left: auto;
}

.verificated {
  margin-top: 17px;
  margin-left: 5px;
}

.progressbar {
  margin-left: 17px;
  width: 80%;
  margin-bottom: 16px;
}

.shop-point-tittle {
  margin-left: 17px;
  font-weight: bold;
  margin-top: 15px;
}

.menu-item {
  margin: 9px 0 10px 17px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.04px;
  text-align: center;
  color: $dark-gray-5;
  font-size: 14px;
}

.background {
  width: 250px;
  height: 40px;
  background-color: $colorN00;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.image-arrow {
  margin-right: 11px;
}

.surveyModalContent {
  margin: 16px 0 5px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.05px;
  color: #1f1f1f;
}

.zIndex {
  z-index: 9999;
}

.user-summary {
  .card {
    min-height: auto;
    padding: 16px 20px;
  }
}

.footer-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 16px;
}

.title {
  font-size: 18px;
  font-weight: 700;
}

.action-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.action-text {
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
}

.action-count {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.count {
  font-size: 20px;
  font-weight: 700;
}

.offer-container {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: $colorL50;
  border-radius: 8px;

  .offer-left {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .offer-link {
    color:$colorN80;
    margin-left: auto;
  }
  p {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
  }
  a {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
  }
}

.sales-graph-detail {
  display: flex;
  flex-direction: row;
  cursor: pointer;

  &-btn {
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
    color: #5d3ebc;
  }
}

.right-arrow {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.68081 5.00433C8.35537 4.67889 7.82773 4.67889 7.5023 5.00433C7.20189 5.30473 7.17879 5.77743 7.43297 6.10434L7.5023 6.18284L11.3208 9.99994L7.5023 13.8082C7.20189 14.1086 7.17879 14.5813 7.43297 14.9082L7.5023 14.9867C7.8027 15.2871 8.27539 15.3103 8.6023 15.0561L8.68081 14.9867L13.0892 10.5892C13.3896 10.2888 13.4127 9.8161 13.1585 9.48919L13.0892 9.41069L8.68081 5.00433Z' fill='%23FF44EE'/%3E%3C/svg%3E");
  width: 18px;
  height: 18px;
  vertical-align: sub;
}

@media screen and (max-width: 1200px) {
  .flex-container {
    margin-top: 50px;
  }

  .main-area {
    width: 100%;
    padding: 30px;
  }

  .side-area {
    width: 100%;
  }

  .card-wrapper {
    width: 45%;
  }
}

@media screen and (max-width: 767px) {
  .navbar {
    display: none;
  }

  .flex-container {
    display: block;
    margin-top: 0;
  }

  .main-area {
    width: 100%;
    gap: 8px;
    padding: 20px 0 0 0;
  }

  .shop-rectangle {
    margin: 0;
    height: 213px;
    display: flex;
  }

  .side-area {
    width: 100%;
    gap: 8px;
    margin-top: 8px;
    max-width: 100%;

    div:nth-child(n) {
      margin-bottom: 0;
    }
  }

  .rectangle-card {
    width: 100%;
  }

  .opportunities-card {
    max-width: 100%;
  }

  .details-banner-area {
    width: 100%;
    height: 100%;
  }

  .statistics {
    width: 100%;
    margin: 0;
  }

  .dummy {
    width: 100%;
  }

  .support-card {
    width: 100%;
    margin: 0;
  }

  .campaign-card {
    margin: 0;
    width: 100%;
  }

  .card-wrapper {
    margin: 0 !important;
    width: 100%;
  }

  .shop {
    width: 100%;
    margin-top: 8px;
  }

  .performance {
    margin: 0;
    width: 100%;
  }

  .shop-profile-card {
    margin: 0;
  }

  .card {
    border-radius: 0;
  }

  .zIndex {
    z-index: 0;
  }
  .special-offers {
    display: flex;
    flex-direction: column;
    width: 177px;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
}
</style>
